import Utilities from "../../foundation/Utility";
import React from "react";
import File from "../../types/files/File";
import Folder from "../../types/files/Folder";
import {
    FileExplorerType,
    FileExplorerTypes,
} from "../../types/system/FileExplorer";
import FileExplorerDialogEntry from "./FileExplorerEntry";

interface FileExplorerLevelProps {
    type: FileExplorerType;
    parentId: number;
    root?: Folder;
    allData: File[];
    selected: File;
    className?: string;
    
    onClick: (data: File) => void;
}

interface FileExplorerLevelState {}

class FileExplorerLevel extends React.Component<
    FileExplorerLevelProps,
    FileExplorerLevelState
> {
    filterTypes(item: File) {
        if (
            item.folderId === 0 &&
            this.props.root &&
            item.id !== this.props.root.id
        )
            return false;

        if (this.props.type === FileExplorerTypes.Any) return true;

        switch (item.fileType.toUpperCase()) {
            case "TIMETABLEFILE":
                return (
                    this.props.type === FileExplorerTypes.Timetables ||
                    this.props.type === FileExplorerTypes.Files
                );
            case "STUDENTOPTIONSFILE":
                return (
                    this.props.type === FileExplorerTypes.StudentOptions ||
                    this.props.type === FileExplorerTypes.Files
                );
            case "DAILYORGANISERFILE":
                return (
                    this.props.type === FileExplorerTypes.DailyOrganisers ||
                    this.props.type === FileExplorerTypes.Files
                );
            case "FOLDER":
                return true;
        }
    }

    render() {
        return (
            <div className={`level${this.props.className ? ` ${this.props.className}` : ""}`}>
                {this.props.allData
                    .filter(
                        item =>
                            item.folderId === this.props.parentId &&
                            this.filterTypes(item),
                    )
                    .sort(Utilities.getSorter(["-isFolder", "name"]))
                    .map((entry, index) => (
                        <FileExplorerDialogEntry
                            key={index}
                            type={this.props.type}
                            data={entry}
                            allData={this.props.allData}
                            selected={this.props.selected}
                            onClick={data => this.props.onClick(data)}
                        />
                    ))}
            </div>
        );
    }
}

export default FileExplorerLevel;
